import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from 'react-icons/io5';
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";

function Menu() {
  const baseURL = process.env.REACT_APP_Baseurl
  const indexApi = `${baseURL}/admin/menu/index`
  const deleteApi = `${baseURL}/admin/menu/multi-delete`
  const suffleApi = `${baseURL}/admin/menu/ordering`

  const { fetchRequest, deleteImageFile } = useMyContext()
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [apiData, setApiData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true)
  const [modalClose, setModelClose] = useState(false)
  const [selectAllData, setSelectAllData] = useState(false);
  const [itemDelete, setItemDelete] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [filter, setFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [isBackgroundColor, setIsBackgroundColor] = useState(0);
  const [menuSettingId, setMenuSettingId] = useState(null);
  const [savingSettings, setSavingSettings] = useState(false);

  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })


  const handleDeleteImage = async () => {
    await deleteImageFile(itemDelete, "Menu");
  }

  const handleDelete = async () => {
    setShowOverlay(true);
    handleCloseModal()
    await handleDeleteImage();
    try {
      const response = await fetchRequest({
        method: 'DELETE',
        url: `${deleteApi}`,
        params: {},
        data: { id: [...itemDelete] },
      })

      const result = response;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
        setSelectAllData(false)
      }
    }
    catch (err) {
      const errMessage = err?.response?.data?.message
      toast.error(errMessage)
    }
    finally {
      setLoading(false)
      setShowOverlay(false);
    }
  }

  const saveShuffleOrder = async (updatedItems) => {
    setShowOverlay(true);

    if (!updatedItems || updatedItems?.length === 0) {
      toast.error("Menu items are empty");
      return;
    }
    else {
      const ids = updatedItems?.map((menuItem) => menuItem?.id);
      const positions = updatedItems?.map((_, index) => index + 1);
      const requestData = {
        id: ids,
        position: positions,
      };
      try {
        const response = await fetchRequest({
          method: 'PATCH',
          url: `${suffleApi}`,
          params: {},
          data: requestData,
        })
        const result = response;
        if (result?.status) {
          toast.success(result?.message)
          setWithOutRefresh(!withOutRefresh)
          setShowOverlay(false);
        }
        else {
          setShowOverlay(false)
          toast.error(result?.message)
        }
      } catch (err) {
        setShowOverlay(false)
        console.error(err);
        var errorMessage = err?.response?.data?.message;
        toast.error(errorMessage)
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(apiData);
    const [movedItem] = reorderedItems?.splice(result.source.index, 1);
    reorderedItems?.splice(result.destination.index, 0, movedItem);
    setApiData(reorderedItems);
    saveShuffleOrder(reorderedItems);
  };

  const handleSelectAllData = () => {
    setSelectAllData(!selectAllData);
    setItemDelete(selectAllData ? [] : apiData?.map((item) => item?.id));
  };

  const handleSingleFile = (itemId) => {
    if (itemDelete?.includes(itemId)) {
      setItemDelete(
        itemDelete?.filter((id) => id !== itemId)
      );
    } else {
      setItemDelete([...itemDelete, itemId]);
    }
  };

  const handleCloseModal = () => {
    setModelClose(!modalClose)
    setItemDelete([]);
  }

  const handleOpenDeleteModal = async () => {
    setModelClose(true)
  }

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const newStatus = currentItem?.active === 1 ? 0 : 1;

      const formData = {
        menu_id: currentItem?.id,
        active: newStatus,
      };

      const response = await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/active-menu`,
        params: {},
        data: formData,
      })
      const result = response
      if (result.status) {
        setWithOutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const handleToggle = async (e, item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemDelete([]);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemDelete([id]);
  };

  const totalPages = Math.ceil(apiData?.length / itemsPerPage);
  const currentPageData = apiData?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = apiData?.slice(indexOfFirstItem, indexOfLastItem);
  const reloadAction = () => {
    setWithOutRefresh(prev => !prev)
  }

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);

    if (searchTerm.trim() === '') {
      setFilteredData(apiData); // ✅ show full data when empty
      return;
    }
    const filteredResults = apiData?.filter((item) =>
      ["id", "name", "mobile", "email", "role", "title", "albumname"].some((property) =>
        typeof item[property] === "string" &&
        item[property].toLowerCase().includes(searchTerm)
      ) ||
      (typeof item.id === "number" && item.id.toString().includes(searchTerm))
    );
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter('');
    setFilteredData(apiData); // Reset to full list
  };
  const fetchData = async (type) => {
    setShowOverlay(true);
    setLoading(true);
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${indexApi}`,
        params: {},
        data: {},
      });

      if (response?.status) {
        const updatedList = response?.menus;
        setApiData(updatedList);
        setFilteredData(updatedList);
        if (type === "CSV") {
          await donwloadCSV(updatedList, "MAIN-MENU-LIST");
        }
        if (type === "PDF") {
          await downloadPDF(updatedList, "MAIN-MENU-LIST", ["S.NO", "ID", "NAME"]);
        }
        if (type === "XLSX") {
          await downloadXLSX(updatedList, "MAIN-MENU-LIST", ["S.NO", "ID", "NAME"]);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setShowOverlay(false);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMenuSettings();
    fetchData();
  }, [withOutRefresh]);

  const fetchMenuSettings = async () => {
    try {
      const settingsResponse = await fetchRequest({
        method: 'GET',
        url: `${baseURL}/admin/menu-settings/index`,
      });
      if (settingsResponse?.status) {
        setIsBackgroundColor(settingsResponse.menuSetting?.is_background_color ?? 0);
        setMenuSettingId(settingsResponse.menuSetting?.id);
      }
    } catch (error) {
      console.error("Error fetching menu settings:", error);
    }
  };

  const handleUpdateMenuSettings = async () => {
    setSavingSettings(true);
    setShowOverlay(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/menu-settings/update`,
        data: {
          is_background_color: isBackgroundColor ? 1 : 0,
        }
      });
      if (response?.status) {
        toast.success(response.message || "Settings updated successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update settings");
    } finally {
      setSavingSettings(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {/* {showOverlay && <Response_Processing />} */}
      {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={closeModal} deleteAction={handleDelete} buttonText={itemDelete?.length} />}
      {showModal ? <AdminSliderModal modalDescription={`Do you want to  ${currentItem?.active == 1 ? 'disable' : 'enable'} this menu ?`} modalHeading={"Menu Status"} modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.active} /> : ""}
      <AdminNavbar heading={'All Menus'} totalDataLength={apiData?.length} deleteCount={itemDelete?.length} navigation={'/addmenu'} deleteMethod={handleOpenDeleteModal} navText={'Add Menu'} />

      {/* Menu Settings Bar */}
      <div className="theme-bg-color p-3 rounded-2 mb-3 d-flex align-items-center justify-content-end gap-4 shadow-sm border theme-border-color">
        <div className="d-flex align-items-center gap-2">
          <span className="theme-text-color admin-input-title mb-0">Enable Background Color</span>
          <label className="switch mb-0">
            <input
              type="checkbox"
              checked={isBackgroundColor === 1}
              onChange={(e) => setIsBackgroundColor(e.target.checked ? 1 : 0)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <button
          onClick={handleUpdateMenuSettings}
          disabled={savingSettings}
          className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-4 border-0"
        >
          {savingSettings ? "Saving..." : "Save Settings"}
        </button>
      </div>

      <div className="bootstrapTable theme-bg-color p-3 rounded-2">
        <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
          <div className="filterContainer">
            <input type='text' placeholder="Search" className="filter form-control theme-text-color theme-bg-color theme-border-secondary" value={filter} onChange={(event) => handleFilter(event)} />
            {filter?.length > 0 && (<button type="button" className="clearBtn" onClick={() => handleClear()}  ><IoClose className="custom-close-btn" /> </button>)}
          </div>
          <div className='d-flex align-items-center'>

            <button id="reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            {/* <div className="dropdown d-block ms-2" key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li id="exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchData("CSV")}>CSV</li>
                <li id="exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchData("PDF")}>PDF</li>
                <li id="exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchData("XLSX")}>XLSX </li>
              </ul>
            </div> */}
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li id="exportallCSV" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("CSV", "ALL")}>CSV</li>
                <li id="exportallPDF" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("PDF", "ALL")}>PDF</li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="">
          {/* Header Row */}
          <div className="row mx-3 theme-border-bottom-secondary pb-3">
            <div className="rowCheckboxDrag">
              <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /></label>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-4">
              <label className="theme-text-color fw-bold fs-6">Menu Name</label>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <label className="theme-text-color fw-bold fs-6">Status</label>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3 text-center">
              <label className="theme-text-color fw-bold fs-6">Actions</label>
            </div>
          </div>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="menu-items" className="theme-bg-color">
              {(provided) => (
                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-3 px-0 theme-bg-color m-0 p-0 list-unstyled">
                  {loading ? <NoRecordTable result={filteredData?.length} loader={true} /> :
                    filteredData?.length ? filteredData?.map((item, index) => (
                      <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                        {(provided) => (
                          <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary px-3`} >
                            <div className="row m-0 p-0 align-items-center">

                              <div className="rowCheckboxDrag category-order-title">
                                <input
                                  type="checkbox"
                                  checked={itemDelete?.includes(item.id)}
                                  onChange={() => handleSingleFile(item.id)}
                                />
                              </div>

                              <div className="col-lg-4 col-md-4 col-sm-4 col-4  category-order-title">
                                <div className="d-flex justify-content-between align-items-center ">
                                  <img src={item?.image} className="profile" alt="image_all" />
                                  <div className="rightVideoTitle d-flex flex-column ">
                                    <MessageBox text={`${item?.name}`} classname="admin-input-title" loadingHide />
                                    <span className="dateText table-subheading "> {item?.upload_on}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-sm-4 col-4  category-order-title">
                                <AdminSwitch name="active" checked={item?.active == 1} onChange={(e) => handleToggle(e, item)} id={item?.id} />
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3 col-3 category-order-title">
                                <div className="editdropdown">
                                  <span className="editdropdown-button">
                                    <FaEllipsisVertical className="theme-text-color" />
                                  </span>
                                  <div className="editdropdown-menu theme-bg-color">
                                    <Link to={`/editmenu/${item?.id}`} className="theme-text-color theme-bg-color">
                                      <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                      <MessageBox text="Edit" classname='ms-2 theme-text-color' />
                                    </Link>
                                    <div onClick={() => singleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                      <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                      <MessageBox text="Delete" classname='ms-2 theme-text-color' />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    )) : <NoRecordTable result={apiData?.length} loader={false} />}
                </ul>
              )}
            </Droppable>
          </DragDropContext>

          {/* ⬇️ Moved pagination block inside here */}
          {/* <div className="row mt-2 align-items-center">
            <div className="col-md-6 d-flex align-items-center">
              <div className="me-3">
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                  className="form-select form-select-sm"
                  style={{ width: '61px', height: '37px' }}
                >
                  {[5, 10, 20].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="mt-0 theme-text-color opacity-75 admin-input-description">
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, apiData?.length)} of {apiData?.length} entries
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <nav className="d-flex justify-content-end">
                <ul className="pagination pagination-md mb-0">
                 
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(1)}>
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>

                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}>
                      Prev
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => (
                    <li key={i} className={`page-item ${i + 1 === currentPage ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}>
                      Next
                    </button>
                  </li>

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(totalPages)}>
                      <MdOutlineKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

          </div> */}
          {/* ⬆️ Pagination ends here */}
        </div>
      </div>



    </>
  );
}
export default Menu;